import { render, staticRenderFns } from "./MypageDashboardPage.vue?vue&type=template&id=022ba55b&"
import script from "./MypageDashboardPage.vue?vue&type=script&lang=js&"
export * from "./MypageDashboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports